import React, { useEffect, useState } from "react";
import queryString from "query-string";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { formatCurrency, formatNumber, toast } from "../../utils/helpers";
import dayjs from "dayjs";
import Loader from "../general/Loader";
import { request } from "../../utils/request";

const ReporteCierre = () => {
    const [reporte, setReporte] = useState({});
    const [cuentas, setCuentas] = useState([]);
    const [inventario, setInventario] = useState([]);
    const [cxc, setCxc] = useState([]);
    const [cxp, setCxp] = useState([]);

    const getReporte = async () => {
        const response = await request(apiUrl(`reportes` + window.location.search));

        if (response.success) {
            const reporte = response.data;
            setReporte(reporte);
            setCuentas(reporte.entradas.filter(c => c.tipo === 'cuenta_bancaria'));
            setCxc(reporte.entradas.filter(c => c.tipo === 'cxc'));
            setCxp(reporte.entradas.filter(c => c.tipo === 'cxp'));
            setInventario(reporte.entradas.filter(c => c.tipo === 'valor_inventario'));
        }

        if (response.code === 422) {
            toast("Error al cargar el reporte.", "error");
        }
    };

    useEffect(() => {
        getReporte();
    }, []);

    if (!reporte.nombre) {
        return <Loader />;
    }

    const pesos = cuentas.filter(c => c.data.moneda === 'DOP');
    const dolares = cuentas.filter(c => c.data.moneda === 'USD');

    return (
        <div>
            <div className='row'>
                <h2 className='col-md-12 text-center m-b-5'>
                    {reporte.nombre}
                </h2>
                <div className='col-md-12 text-center'>
                    {reporte.sucursal.nombre} - {reporte.sucursal.direccion} •{" "}
                    {dayjs(reporte.fecha_inicio).format("DD/MM/YYYY")} -{" "}
                    {dayjs(reporte.fecha_fin).format("DD/MM/YYYY")}
                </div>
            </div>
            {pesos.length > 0 && (<>

                <h4 className="uppercase mt-5 mb-2">Cuentas Pesos:</h4>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Banco</th>
                            <th>Moneda</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cuentas.filter(c => c.data.moneda === 'DOP').map((row, index) => {
                            const cuenta = row.data;
                            return (
                                <tr key={index}>
                                    <td>{cuenta.nombre}</td>
                                    <td>{cuenta.banco}</td>
                                    <td>{cuenta.moneda}</td>
                                    <td>{formatCurrency(cuenta.balance)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </>)}
            {dolares.length > 0 && (<>
                <h4 className="uppercase mt-5 mb-2">Cuentas Dólares:</h4>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Banco</th>
                            <th>Moneda</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cuentas.filter(c => c.data.moneda === 'USD').map((row, index) => {
                            const cuenta = row.data;
                            return (
                                <tr key={index}>
                                    <td>{cuenta.nombre}</td>
                                    <td>{cuenta.banco}</td>
                                    <td>{cuenta.moneda}</td>
                                    <td>{formatCurrency(cuenta.balance)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </>)}

            <div className="row">
                {cxc.map((data) => {
                    const row = data.data;
                    return (
                        <div className="col">
                            <h4 className="uppercase mt-5 mb-2">{row.nombre}</h4>
                            <div>{formatCurrency(row.balance)}</div>
                        </div>
                    );
                })}
                {cxp.map((data) => {
                    const row = data.data;
                    return (
                        <div className="col">
                            <h4 className="uppercase mt-5 mb-2">{row.nombre}</h4>
                            <div>{formatCurrency(row.balance)}</div>
                        </div>
                    );
                })}
                {inventario.map((data) => {
                    const row = data.data;
                    return (
                        <div className="col">
                            <h4 className="uppercase mt-5 mb-2">{row.nombre}</h4>
                            <div>{formatCurrency(row.balance)}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ReporteCierre;
